// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type Toast = {
  id: number;
  type: ToastTypeEnum;
  message: string;
};

export enum ToastTypeEnum {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
